import { cn } from "@/lib/utils"

export default function FormFieldError({ error, className }: { error?: string | null; className?: string }) {
  return (
    error && (
      <div className={cn("animate-shake text-sm text-red-500", className)} role="alert">
        <ul className="list-inside list-disc">
          <li>{error}</li>
        </ul>
      </div>
    )
  )
}
